<template>
  <v-modal :start-closed="true" :is-big="true" id="modalDietHistory">
    <span slot="header"> Diario Alimentare di {{ guest_diets_history.full_name }} </span>
    <error :error-messages="errorMessages" v-if="error_response" />
    <ul class="nav nav-pills text-uppercase">
      <li class="active">
        <a href="#breakfast" class="js-tab-anchor" data-toggle="tab">
          {{ i18nJS['breakfast_l'] }}
        </a>
      </li>
      <li>
        <a href="#spunt1" class="js-tab-anchor" data-toggle="tab">
          {{ i18nJS['meta_mattina'] }}
        </a>
      </li>
      <li>
        <a href="#lunch" class="js-tab-anchor" data-toggle="tab">
          {{ i18nJS['launch_l'] }}
        </a>
      </li>
      <li>
        <a href="#spunt2" class="js-tab-anchor" data-toggle="tab">
          {{ i18nJS['meta_pomeriggio'] }}
        </a>
      </li>
      <li>
        <a href="#dinner" class="js-tab-anchor" data-toggle="tab">
          {{ i18nJS['dinner_l'] }}
        </a>
      </li>
      <li>
        <a href="#drinks" class="js-tab-anchor" data-toggle="tab">
          {{ i18nJS['bevande'] }}
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane active" id="breakfast">
        <br />
        <div class="row-fluid">
          <div class="span6"></div>
          <div class="span1 center">
            {{ i18nJS['quantita'] }}
          </div>
          <div class="span1 center">
            {{ i18nJS['freq'] }}
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['te_caffe'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_te_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_te_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['zucchero_miele'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_zucchero_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_zucchero_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['colazione_latte_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`colazione_latte_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.colazione_latte_ecc_tipo"
              :options-list="[[guest_diets_history.get_colazione_latte_ecc_tipo, guest_diets_history.colazione_latte_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/latte_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_latte_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_latte_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['colazione_yogurt_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`colazione_yogurt_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.colazione_yogurt_ecc_tipo"
              :options-list="[[guest_diets_history.get_colazione_yogurt_ecc_tipo, guest_diets_history.colazione_yogurt_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/latte_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_yogurt_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_yogurt_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['colazione_pane_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`colazione_pane_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.colazione_pane_ecc_tipo"
              :options-list="[[guest_diets_history.get_colazione_pane_ecc_tipo, guest_diets_history.colazione_pane_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/pane_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_pane_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_pane_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['colazione_fette_bisc_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`colazione_fette_bisc_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.colazione_fette_bisc_ecc_tipo"
              :options-list="[[guest_diets_history.get_colazione_fette_bisc_ecc_tipo, guest_diets_history.colazione_fette_bisc_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/fette_biscottate_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_fette_bisc_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_fette_bisc_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['colazione_cereali_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`colazione_cereali_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.colazione_cereali_ecc_tipo"
              :options-list="[[guest_diets_history.get_colazione_cereali_ecc_tipo, guest_diets_history.colazione_cereali_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/cereali_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_cereali_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_cereali_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['colazione_grissini_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`colazione_grissini_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.colazione_grissini_ecc_tipo"
              :options-list="[[guest_diets_history.get_colazione_grissini_ecc_tipo, guest_diets_history.colazione_grissini_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/grissini_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_grissini_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_grissini_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['colazione_biscotti_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`colazione_biscotti_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.colazione_biscotti_ecc_tipo"
              :options-list="[[guest_diets_history.get_colazione_biscotti_ecc_tipo, guest_diets_history.colazione_biscotti_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/biscotti_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_biscotti_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_biscotti_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['colazione_torta_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_torta_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.colazione_torta_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
      </div>
      <div class="tab-pane" id="spunt1">
        <br />
        <div class="row-fluid">
          <div class="span6"></div>
          <div class="span1 center">
            <label>{{ i18nJS['quantita'] }}</label>
          </div>
          <div class="span1 center">
            <label>{{ i18nJS['freq'] }}</label>
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['mezza_matt_yogurt_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`mezza_matt_yogurt_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.mezza_matt_yogurt_ecc_tipo"
              :options-list="[[guest_diets_history.get_mezza_matt_yogurt_ecc_tipo, guest_diets_history.mezza_matt_yogurt_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/latte_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezza_matt_yogurt_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezza_matt_yogurt_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['mezza_matt_frutta_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezza_matt_frutta_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezza_matt_frutta_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['mezza_matt_prod_forno_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezza_matt_prod_forno_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezza_matt_prod_forno_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['altro'] }}</label>
          </div>
          <div class="span4">
            <input :disabled="!canManage" type="text" v-model="guest_diets_history.mezza_matt_altro_descrizione" />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezza_matt_altro_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezza_matt_altro_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
      </div>
      <div class="tab-pane" id="lunch">
        <br />
        <div class="row-fluid">
          <div class="span6"></div>
          <div class="span1 center">
            <label>{{ i18nJS['quantita'] }}</label>
          </div>
          <div class="span1 center">
            <label>{{ i18nJS['freq'] }}</label>
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_minestre_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_minestre_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_minestre_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_pasta_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pasta_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pasta_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_pasta_ripiena_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pasta_ripiena_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pasta_ripiena_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_pasta_legumi_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pasta_legumi_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pasta_legumi_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_sugo_pomodoro_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_sugo_pomodoro_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_sugo_pomodoro_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_ragu_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_ragu_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_ragu_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['pranzo_carne_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`pranzo_carne_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.pranzo_carne_ecc_tipo"
              :options-list="[[guest_diets_history.get_pranzo_carne_ecc_tipo, guest_diets_history.pranzo_carne_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/carne_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_carne_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_carne_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_pesce_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pesce_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pesce_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_salumi_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_salumi_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_salumi_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_formaggi_freschi_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_formaggi_freschi_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_formaggi_freschi_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_formaggi_stagionati_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_formaggi_stagionati_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_formaggi_stagionati_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_uova_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_uova_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_uova_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_verdura_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_verdura_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_verdura_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_patate_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_patate_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_patate_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_legumi_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_legumi_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_legumi_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['colazione_pane_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`pranzo_pane_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.pranzo_pane_ecc_tipo"
              :options-list="[[guest_diets_history.get_pranzo_pane_ecc_tipo, guest_diets_history.pranzo_pane_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/pane_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pane_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pane_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_pizza_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pizza_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_pizza_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['mezza_matt_frutta_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_frutta_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_frutta_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_olio_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_olio_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_olio_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_burro_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_burro_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.pranzo_burro_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
      </div>
      <div class="tab-pane" id="spunt2">
        <br />
        <div class="row-fluid">
          <div class="span6"></div>
          <div class="span1 center">
            <label>{{ i18nJS['quantita'] }}</label>
          </div>
          <div class="span1 center">
            <label>{{ i18nJS['freq'] }}</label>
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['mezza_matt_yogurt_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`mezzo_pom_yogurt_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.mezzo_pom_yogurt_ecc_tipo"
              :options-list="[[guest_diets_history.get_mezzo_pom_yogurt_ecc_tipo, guest_diets_history.mezzo_pom_yogurt_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/latte_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezzo_pom_yogurt_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezzo_pom_yogurt_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['mezza_matt_frutta_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezzo_pom_frutta_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezzo_pom_frutta_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['mezza_matt_prod_forno_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezzo_pom_prod_forno_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezzo_pom_prod_forno_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['altro'] }}</label>
          </div>
          <div class="span4">
            <input :disabled="!canManage" type="text" v-model="guest_diets_history.mezzo_pom_altro_descrizione" />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezzo_pom_altro_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.mezzo_pom_altro_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
      </div>
      <div class="tab-pane" id="dinner">
        <br />
        <div class="row-fluid">
          <div class="span6"></div>
          <div class="span1 center">
            <label>{{ i18nJS['quantita'] }}</label>
          </div>
          <div class="span1 center">
            <label>{{ i18nJS['freq'] }}</label>
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_minestre_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_minestre_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_minestre_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_pasta_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pasta_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pasta_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_pasta_ripiena_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pasta_ripiena_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pasta_ripiena_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_pasta_legumi_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pasta_legumi_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pasta_legumi_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_sugo_pomodoro_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_sugo_pomodoro_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_sugo_pomodoro_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_ragu_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_ragu_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_ragu_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_verdura_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_verdura_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_verdura_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_patate_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_patate_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_patate_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_legumi_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_legumi_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_legumi_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['colazione_pane_ecc_tipo'] }}</label>
          </div>
          <div class="span4 mychzn">
            <v-select2
              :disabled="!canManage"
              :key="`cena_pane_ecc_tipo_${guest_diets_history.id}`"
              v-model="guest_diets_history.cena_pane_ecc_tipo"
              :options-list="[[guest_diets_history.get_cena_pane_ecc_tipo, guest_diets_history.cena_pane_ecc_tipo]]"
              :data-ajax--url="`/it/decodes_configs/autocomplete/dieta/pane_tipo`"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pane_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pane_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_pizza_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pizza_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_pizza_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['mezza_matt_frutta_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_frutta_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_frutta_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_olio_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_olio_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_olio_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span6">
            <label>{{ i18nJS['pranzo_burro_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_burro_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.cena_burro_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
      </div>
      <div class="tab-pane" id="drinks">
        <br />
        <div class="row-fluid">
          <div class="span2"></div>
          <div class="span1 center">
            <label>{{ i18nJS['quantita'] }}</label>
          </div>
          <div class="span1 center">
            <label>{{ i18nJS['freq'] }}</label>
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['acqua'] }}</label>
          </div>
          <div class="span1 center">
            <input :disabled="!canManage" type="number" v-model="guest_diets_history.acqua_ecc_qta" min="0" step="1" class="input-mini" />
          </div>
          <div class="span1 center">
            <input :disabled="!canManage" type="number" v-model="guest_diets_history.acqua_ecc_freq" min="0" step="1" class="input-mini" />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['aperitivi_ecc'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.aperitivi_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.aperitivi_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['vino'] }}</label>
          </div>
          <div class="span1 center">
            <input :disabled="!canManage" type="number" v-model="guest_diets_history.vino_ecc_qta" min="0" step="1" class="input-mini" />
          </div>
          <div class="span1 center">
            <input :disabled="!canManage" type="number" v-model="guest_diets_history.vino_ecc_freq" min="0" step="1" class="input-mini" />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['birra'] }}</label>
          </div>
          <div class="span1 center">
            <input :disabled="!canManage" type="number" v-model="guest_diets_history.birra_ecc_qta" min="0" step="1" class="input-mini" />
          </div>
          <div class="span1 center">
            <input :disabled="!canManage" type="number" v-model="guest_diets_history.birra_ecc_freq" min="0" step="1" class="input-mini" />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['super_alcolici'] }}</label>
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.super_alcolici_ecc_qta"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
          <div class="span1 center">
            <input
              :disabled="!canManage"
              type="number"
              v-model="guest_diets_history.super_alcolici_ecc_freq"
              min="0"
              step="1"
              class="input-mini"
            />
          </div>
        </div>
        <div class="row-fluid">
          <div class="span2">
            <label>{{ i18nJS['bibite'] }}</label>
          </div>
          <div class="span1 center">
            <input :disabled="!canManage" type="number" v-model="guest_diets_history.bibite_ecc_qta" min="0" step="1" class="input-mini" />
          </div>
          <div class="span1 center">
            <input :disabled="!canManage" type="number" v-model="guest_diets_history.bibite_ecc_freq" min="0" step="1" class="input-mini" />
          </div>
        </div>
      </div>
    </div>

    <a v-if="canManage" slot="footer" ref="btnSave" class="btn btn-success" href="javascript:void(0)" @click="save">
      {{ i18nJS['save'] }}
    </a>
  </v-modal>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import vModal from '../vModal';
import error from '../error';
import vSelect2 from '../vSelect2';
import { LabelApi } from '@/epersonam/mixins/labels.js';
import { manageErrors } from '../../mixins/manageErrors.js';
import FaIcon from '../faIcon';

export default {
  name: 'modalDietHistory',
  components: {
    vModal,
    vSelect2,
    error,
  },
  mixins: [LabelApi, manageErrors],
  data() {
    return {
      guest_diets_history: {},
      gbu_id: null,
      date: null,
      can_edit: false,
      modalRegistered: false,
    };
  },
  computed: {
    url() {
      return `/it/guest_business_units/${this.gbu_id}/guest_diets_histories/${this.date}`;
    },
    modal() {
      return $('#modalDietHistory');
    },
    canManage() {
      return this.can_edit && ((this.guest_diets_history.id && this.guest_diets_history.can_edit) || this.guest_diets_history.can_create);
    },
  },
  methods: {
    save() {
      Loader.show();
      if (this.guest_diets_history.id) {
        apiConnector()
          .put(`${this.url}/${this.guest_diets_history.id}`, { guest_diets_history: this.guest_diets_history })
          .then(() => this.modal.modal('hide'))
          .catch((err) => {
            this.error_response = err.response;
          })
          .finally(() => Loader.hide());
      } else {
        apiConnector()
          .post(this.url, { guest_diets_history: this.guest_diets_history })
          .then(() => this.modal.modal('hide'))
          .catch((err) => {
            this.error_response = err.response;
          })
          .finally(() => Loader.hide());
      }
    },
  },
  async beforeMount() {
    this.neededlabels = [
      'acqua',
      'altro',
      'aperitivi_ecc',
      'bevande',
      'bibite',
      'birra',
      'breakfast_l',
      'clic_per_selezionare',
      'colazione_biscotti_ecc_tipo',
      'colazione_cereali_ecc_tipo',
      'colazione_fette_bisc_ecc_tipo',
      'colazione_grissini_ecc_tipo',
      'colazione_latte_ecc_tipo',
      'colazione_pane_ecc_tipo',
      'colazione_torta_ecc',
      'colazione_yogurt_ecc_tipo',
      'decode',
      'dinner_l',
      'freq',
      'launch_l',
      'meta_mattina',
      'meta_pomeriggio',
      'mezza_matt_frutta_ecc',
      'mezza_matt_prod_forno_ecc',
      'mezza_matt_yogurt_ecc_tipo',
      'pranzo_burro_ecc',
      'pranzo_carne_ecc_tipo',
      'pranzo_formaggi_freschi_ecc',
      'pranzo_formaggi_stagionati_ecc',
      'pranzo_legumi_ecc',
      'pranzo_minestre_ecc',
      'pranzo_olio_ecc',
      'pranzo_pasta_ecc',
      'pranzo_pasta_legumi_ecc',
      'pranzo_pasta_ripiena_ecc',
      'pranzo_patate_ecc',
      'pranzo_pesce_ecc',
      'pranzo_pizza_ecc',
      'pranzo_ragu_ecc',
      'pranzo_salumi_ecc',
      'pranzo_sugo_pomodoro_ecc',
      'pranzo_uova_ecc',
      'pranzo_verdura_ecc',
      'quantita',
      'super_alcolici',
      'te_caffe',
      'vino',
      'zucchero_miele',
    ];
    await this.setupLabels();
  },
  mounted() {
    eventBus.$on('loadGuestDietHistory', (gbu_id, date, can_edit) => {
      this.gbu_id = gbu_id;
      this.date = date;
      this.can_edit = can_edit;

      if (!this.modalRegistered) {
        $('#modalDietHistory').on('hidden', () => {
          this.guest_diets_history = {};
          this.error_response = null;
        });
        this.modalRegistered = true;
      }

      apiConnector()
        .get(this.url)
        .then(({ data }) => {
          this.guest_diets_history = data;
        })
        .catch((err) => {
          this.error_response = err.response;
        })
        .finally(() => $('#modalDietHistory').modal('show'));
    });
  },
};
</script>
<style lang="scss" scoped></style>
